import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';
import classNames from 'classnames/bind';

import Heading from 'components/shared/heading';
import Link from 'components/shared/link';
import ArrowIcon from './images/arrow.inline.svg';
import shape1 from './images/shape-1.svg';
import shape2 from './images/shape-2.svg';

import styles from './recent-articles.module.scss';

const cx = classNames.bind(styles);

const RecentArticles = ({ title, background }) => {
  const {
    allWpPost: { edges: items },
  } = useStaticQuery(graphql`
    query {
      allWpPost(limit: 4, sort: { date: DESC }) {
        edges {
          node {
            title
            categories {
              nodes {
                name
              }
            }
            uri
            acf {
              description
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(height: 280)
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  return (
    <section className={cx('wrapper', background)}>
      <div className={cx('container')}>
        <Heading className={cx('title')} tag="h2" size="xl">
          {title}
        </Heading>
        <div className={cx('items-wrapper')}>
          {items.map(
            (
              {
                node: {
                  title,
                  categories: { nodes: category },
                  uri,
                  acf: { description, image },
                },
              },
              index
            ) => {
              const imageFluid = image.localFile.childImageSharp;
              return (
                <article className={cx('item')} key={index}>
                  <Link className={cx('inner')} to={uri}>
                    <div className={cx('content-wrapper')}>
                      <div className={cx('content')}>
                        <Heading className={cx('item-title')} tag="h3" size="md">
                          {title}
                        </Heading>
                        <p className={cx('description')}>{description}</p>
                        <div className={cx('footer')}>
                          <div className={cx('read-more')}>
                            <span>Read more</span>
                            <ArrowIcon />
                          </div>
                        </div>
                        <span className={cx('category')}>{category[0].name}</span>
                      </div>
                    </div>
                    <div className={cx('image-wrapper')}>
                      <GatsbyImage
                        className={cx('image')}
                        image={getImage(imageFluid)}
                        alt={title}
                      />
                    </div>
                  </Link>
                </article>
              );
            }
          )}

          <img className={cx('shape-1')} src={shape1} alt="" loading="lazy" aria-hidden />
          <img className={cx('shape-2')} src={shape2} alt="" loading="lazy" aria-hidden />
        </div>
      </div>
    </section>
  );
};

RecentArticles.propTypes = {
  title: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
};

export default RecentArticles;
